import classNames from 'classnames';
import * as React from 'react';
import toArray from '../_util/childrenToArray';
import { jsx as _jsx } from "react/jsx-runtime";
const spaceSize = {
  l: 8,
  ll: 16,
  lll: 24,
  llll: 32,
  lllll: 40
};
const Space = props => {
  const {
    size = 'l',
    columnGap,
    rowGap,
    align,
    children,
    direction = 'horizontal',
    wrap = 'nowrap',
    splitLine = false,
    isEmptyShow,
    block = false,
    itemWidth,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-space");
  const items = toArray(children, isEmptyShow);
  const len = items.length;
  if (len === 0) {
    return null;
  }
  const mergedAlign = align === undefined && direction === 'horizontal' ? 'center' : align;
  const cn = classNames(baseClassName, "".concat(baseClassName, "-").concat(direction), {
    ["".concat(baseClassName, "-block")]: block,
    ["".concat(baseClassName, "-align-").concat(mergedAlign)]: !!mergedAlign,
    ["".concat(baseClassName, "-wrap-").concat(wrap)]: !!wrap
  }, className);
  const itemClassName = "".concat(baseClassName, "-item");
  const splitClassName = "".concat(baseClassName, "-split");
  return /*#__PURE__*/_jsx("div", {
    ...restProps,
    className: cn,
    style: {
      columnGap: columnGap !== null && columnGap !== void 0 ? columnGap : typeof size === 'string' ? spaceSize[size] : size,
      rowGap: rowGap !== null && rowGap !== void 0 ? rowGap : typeof size === 'string' ? spaceSize[size] : size,
      ...style
    },
    children: items === null || items === void 0 ? void 0 : items.flatMap((child, i) => {
      const elements = [/*#__PURE__*/_jsx("div", {
        className: itemClassName,
        style: itemWidth ? {
          width: typeof itemWidth === 'object' ? itemWidth[i] : itemWidth
        } : undefined,
        children: child
      }, "".concat(itemClassName, "-").concat(i))];
      if (splitLine && i > 0) {
        elements.unshift( /*#__PURE__*/_jsx("i", {
          className: splitClassName
        }, "".concat(splitClassName, "-").concat(i)));
      }
      return elements;
    })
  });
};
export default Space;